import { render, staticRenderFns } from "./InfoCardOthers.vue?vue&type=template&id=6be48922&scoped=true&"
import script from "./InfoCardOthers.vue?vue&type=script&lang=js&"
export * from "./InfoCardOthers.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardOthers.vue?vue&type=style&index=0&id=6be48922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be48922",
  null
  
)

export default component.exports